import { useTranslation } from "react-i18next";

export default function AccommodationOptions() {
  const { t } = useTranslation();
  const propertyOptions = [
    // {
    //   label: t("Dashboard"),
    //   url: "/admin/property",
    // },
    {
      label: t("Calendar"),
      url: "/admin/accommodation/calendar",
    },
    {
      label: t("Reservations"),
      url: "/admin/accommodation/reservations",
    },
    {
      label: t("Rates & Availability"),
      url: "/admin/accommodation/rates/rate-plans",
    },
    {
      label: t("Property Configuration"),
      url: "/admin/accommodation/configuration/locations",
    },
  ];

  return propertyOptions;
}
